/* Isolated community progressive enhancement. Product/image links work without JS. */
(() => {
  if (customElements.get('strides-community-hotspots')) return;
  customElements.define('strides-community-hotspots', class extends HTMLElement {
    connectedCallback() {
      this.close(false);
      this.controller?.abort();
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.addEventListener('click', event => {
        const trigger = event.target.closest('.strides-community__hotspot');
        if (trigger && this.contains(trigger)) {
          event.preventDefault();
          if (trigger === this.activeTrigger) this.close(false);
          else this.open(trigger);
        } else if (event.target.closest('.strides-community__schliessen')) {
          this.close(true);
        }
      }, options);
      document.addEventListener('click', event => {
        if (this.activePanel && !this.activePanel.contains(event.target) && !this.activeTrigger.contains(event.target)) this.close(false);
      }, options);
      document.addEventListener('keydown', event => {
        if (event.key === 'Escape' && this.activePanel) {
          const restoreFocus = this.activePanel.contains(document.activeElement) || this.activeTrigger === document.activeElement;
          this.close(restoreFocus);
          event.preventDefault();
        }
      }, options);
      this.addEventListener('scroll', event => {
        if (event.target.matches?.('.strides-community__band')) this.close(false);
      }, { ...options, capture: true });
      window.addEventListener('resize', () => this.close(false), options);
      this.setAttribute('data-hotspots-ready', '');
    }
    disconnectedCallback() {
      this.close(false);
      this.controller?.abort();
      this.removeAttribute('data-hotspots-ready');
    }
    open(trigger) {
      this.close(false);
      const panelId = trigger.getAttribute('aria-controls');
      const panel = Array.from(this.querySelectorAll('.strides-community__popover')).find(candidate => candidate.id === panelId);
      if (!panel || !this.contains(panel)) return;
      this.activeTrigger = trigger;
      this.activePanel = panel;
      trigger.setAttribute('aria-expanded', 'true');
      panel.hidden = false;
      const card = trigger.closest('.strides-community__kachel');
      // A partially visible card must not clip its panel or close control.
      // Keep the panel inside the visible rail without scrolling/moving the marker.
      const band = card.closest('.strides-community__band');
      const cardRect = card.getBoundingClientRect();
      const bandRect = band.getBoundingClientRect();
      const leftEdge = Math.max(0, bandRect.left) + 8;
      const rightEdge = Math.min(window.innerWidth, bandRect.right) - 8;
      const width = Math.max(1, Math.min(card.clientWidth - 16, rightEdge - leftEdge));
      const left = Math.max(leftEdge, Math.min(cardRect.left + 8, rightEdge - width));
      panel.style.boxSizing = 'border-box';
      panel.style.width = `${width}px`;
      panel.style.left = `${left - cardRect.left}px`;
      panel.style.right = 'auto';
      const y = trigger.offsetTop;
      const preferred = y > card.clientHeight / 2 ? y - 26 - panel.offsetHeight : y + 26;
      panel.style.top = `${Math.max(8, Math.min(preferred, card.clientHeight - panel.offsetHeight - 8))}px`;
    }
    close(restoreFocus) {
      if (!this.activePanel) return;
      this.activePanel.hidden = true;
      this.activeTrigger.setAttribute('aria-expanded', 'false');
      if (restoreFocus && this.activeTrigger.isConnected) this.activeTrigger.focus({ preventScroll: true });
      this.activePanel = null;
      this.activeTrigger = null;
    }
  });
})();
